import { createStyles } from 'antd-style'

export default createStyles(() => {
  return {
    row: {
      display: 'flex',
    },
  }
})
